#import "~/graphql/fragments/sections/default/baseEntryFields.graphql"
#import "~/graphql/fragments/assets/image.graphql"
#import "~/graphql/fragments/sections/discover/articlePreview.graphql"
#import "~/graphql/fragments/sections/discover/eventPreview.graphql"
#import "~/graphql/fragments/sections/discover/newsPreview.graphql"
#import "~/graphql/fragments/sections/discover/projectPreview.graphql"
#import "~/graphql/fragments/sections/discover/dossierPreview.graphql"
#import "~/graphql/fragments/sections/discover/grantAwardedPreview.graphql"
#import "~/graphql/fragments/sections/global-content/video.graphql"

query discoverEntries(
    $site: [String]
    $siteId: [QueryArgument]
    $limit: Int = 6
    $tagIds: [QueryArgument]
    $showInStream: Boolean
    $showOnHome: Boolean
    $types: [String] = ["event", "article", "news", "project", "grantAwarded", "globalVideo"]
) {
    entries(
        site: $site
        siteId: $siteId
        section: ["discover", "globalVideos"]
        limit: $limit
        orderBy: "postDate DESC"
        tags: $tagIds
        showOnHome: $showOnHome
        showInStream: $showInStream
        type: $types
    ) {
        ...articlePreview
        ...eventPreview
        ...newsPreview
        ...projectPreview
        ...dossierPreview
        ...grantAwardedPreview
        ...globalVideoSection
    }
}
